module.exports = __webpack_public_path__ + "static/media/A0.01863b85.pdf";